<template>
  <EditableTableItem
    @opened-field="focusOnInput"
    @click.stop
    @editing="change"
    ref="editable"
  >
    <template #input>
      <div class="input-container d-flex">
        <input class="flex-grow-1 pl-2"
          ref="input"
          type="text"
          v-model="newValue"

          @keydown="saveNewValue"
        />
        <div class="button-group" @click.stop>
          <button class="btn btn-blue" @click="save">Opslaan</button>
          <button class="btn btn-grey" @click="generate">Genereer</button>
        </div>
      </div>
    </template>
    {{ value }}
  </EditableTableItem>
</template>

<script>

import EditableTableItem from "./EditableTableItem.vue"

// import EanGenerator from "ean-generator"

export default {
  components: {
    EditableTableItem,
  },
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      newValue: this.value || "",
    }
  },
  methods: {
    change() {
      if (this.newValue === "---") {
        this.newValue = ""
      }
    },
    generate() {
      // this.newValue = new EanGenerator(["087"]).create()
      this.$handlePromise(async () => {
        this.newValue = (await this.axios.get("/api/ean13")).data.ean13
      })
    },
    
    saveNewValue({key}) {
      if (key !== "Enter") return;

      this.$emit("save", this.newValue)
      this.$refs.editable.editing = false
    },
    save() {
      this.$emit("save", this.newValue)
      this.$refs.editable.editing = false
    },
    focusOnInput() {
      this.newValue = this.value
      this.$nextTick(() => this.$refs.input.focus())
    },
  },
}

</script>

<style scoped>
.btn {
  color: var(--white);
  font-size: 0.8125em;
  padding: 4px !important;
}
.btn-blue {
  background-color: var(--blue);
  border-radius: 0px;
  margin-left: -1px;
}

.btn-grey {
  background-color: var(--black-40);
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}

input {
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}

.input-container {
  border-radius: 1px;
}

input, .input-container {
  width: 130px !important;
}

.button-group {
  display: flex;
  justify-content: space-around;
}
</style>
